<router-outlet></router-outlet>

<ng-container *ngIf="isBrowser">
  <div *ngIf="config.analytic.googleTag" [googleTagManager]="[config.analytic.googleTag]"></div>
</ng-container>

<ui-json-ld
  [jsons]="(meta.jsonLds$ | async)">
</ui-json-ld>
